// extracted by mini-css-extract-plugin
export default {"oneManySorryWrap":"OneManySorry_oneManySorryWrap__xuR8A","subtitleDesktop":"OneManySorry_subtitleDesktop__voV9q","subtitleMobile":"OneManySorry_subtitleMobile__ef97Y"};